module.exports = __webpack_public_path__ + "img-front/register/sogu.94695da6.svg";